import Parallax from "parallax-js";
import MobileDetection from "@chronos/frontend-base/src/mixins/mobile_detection/MobileDetectionMixin";

export default {
  data() {
    return {
      parallax: null,
    };
  },

  mixins: [MobileDetection],

  methods: {
    initParallax(ref) {
      this.parallax = new Parallax(ref, {
        limitY: 100,
        limitX: 100,
      });
      this.parallax.disable();
    },

    enableParallax() {
      this.parallax.enable();
    },

    disableParallax() {
      this.parallax.disable();
    },
  },

  mounted: function() {
    if (this.is_mobile) return false;

    this.initParallax(this.$refs.parallax_container);
  },

  beforeDestroy: function() {
    this.parallax.destroy();
  },
};
